import { useFilterDate } from "@/common/hooks/useFilterDate";
import { useMemo } from "react";
import { DateRange } from "react-day-picker";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentDateFilters, DashboardComponentFilterDefinitions, DashboardComponentFiltersParams, DashboardComponentFiltersParamsParsed } from "../../types/dashboards/dashboardComponent.type";

interface UseDashboardComponentParsedFiltersProps {
  filters: DashboardComponentFiltersParams & {
    date: DateRange | undefined;
  };
  dashboardDesiredFilters: DashboardFilters[];
  definitionFilters: DashboardComponentFilterDefinitions;
}

const useDashboardComponentParsedFilters = ({
  filters,
  dashboardDesiredFilters,
  definitionFilters,
}: UseDashboardComponentParsedFiltersProps) => {
  const { formattedDate } = useFilterDate(filters);

  return useMemo(() => {
    const _transformedFilters: DashboardComponentFiltersParamsParsed = {};

    for (const filterKey of Object.values(DashboardFilters)) {
      if (dashboardDesiredFilters.includes(filterKey)) {
        if (filterKey === DashboardFilters.DateRange) {
          if (DashboardComponentDateFilters.StartDate in definitionFilters) {
            _transformedFilters[DashboardComponentDateFilters.StartDate] = formattedDate.from;
          }

          if (DashboardComponentDateFilters.EndDate in definitionFilters) {
            _transformedFilters[DashboardComponentDateFilters.EndDate] = formattedDate.to;
          }

          continue;
        }

        if (filterKey in definitionFilters) {
          if (filters[filterKey]?.value) {
            _transformedFilters[filterKey] = filters[filterKey]?.value;
          } else {
            _transformedFilters[filterKey] = filters[filterKey];
          }
        }
      }
    }

    return _transformedFilters;
  }, [
    dashboardDesiredFilters.join(','),
    formattedDate.from,
    formattedDate.to,
    filters[DashboardFilters.City]?.value,
    filters[DashboardFilters.Equipment]?.value,
    filters[DashboardFilters.EstablishmentBranch]?.value,
    filters[DashboardFilters.FuelProductsOnly],
    filters[DashboardFilters.EquipmentCategory]?.value,
    filters[DashboardFilters.EquipmentCategoryUnitForConsumption]?.value,
  ])
}

export default useDashboardComponentParsedFilters;
